import dayjs from 'dayjs';
import { isNil } from 'lodash-es';
import { DATE_FORMATS, DateFormat } from 'utils/date/formatDate';

/**
 * Convert a date to unix.
 *
 * @param source date to convert (default now)
 * @param parsingFormat format for parsing
 * @returns Unix timestamp in seconds
 */
const dateToUnix = (source?: Date | string, parsingFormat?: DateFormat) => {
  const dateFormat = isNil(parsingFormat) ? undefined : DATE_FORMATS[parsingFormat];

  return dayjs(source, dateFormat).unix();
};

export default dateToUnix;
